import type { Words } from "./model.ts";

/**
 * What a delete does, in the red question before it (Delete in a row of the swimmers list).
 */

/** "Remove child" of the Families page: Undo, and a booked child is refused. */
export function DeleteChildText({ name, words }: { name: string; words: Words }) {
  return (
    <p>
      {name} leaves your lists. The history stays. You can undo this. A {words.participant} with a session booked cannot be deleted: cancel the bookings first.
    </p>
  );
}

/** "Not our swimmer" of the Link page: a name a coach added that waits for a parent. No Undo. */
export function DeleteWaitingText({ name, words }: { name: string; words: Words }) {
  return (
    <p>
      {name} goes off the list of every {words.staff}. You cannot undo this.
    </p>
  );
}
